import React from 'react'
import PropTypes from 'prop-types'
import Paper from '@material-ui/core/Paper'
import { withStyles } from '@material-ui/core/styles'

const styles = (theme) => ({
  root: {
    backgroundColor: theme.palette.background.paper,
    borderRadius: 18,
    border: theme.custom.cardBorder,
    boxShadow: theme.custom.softShadow,
    padding: theme.spacing(2.5),
    width: '100%',
  },
})

function PageCard({ classes, className, children, ...rest }) {
  return (
    <Paper className={`${classes.root}${className ? ` ${className}` : ''}`} elevation={0} {...rest}>
      {children}
    </Paper>
  )
}

PageCard.propTypes = {
  classes: PropTypes.object.isRequired,
  className: PropTypes.string,
  children: PropTypes.node,
}

export default withStyles(styles)(PageCard)
